<template>
    <main-content v-if="$can('read', 'payment-link')">
        <manage-ps></manage-ps>
    </main-content>
    <main-content v-else>
        <kt-panel>
            <kt-panel-body>
                <ps-form
                        v-if="status !== 'loading'"
                        :form_data="form_data"
                        :submit="submit"
                >
                </ps-form>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import PSForm from './components/form'
import {mapGetters} from "vuex"
import { KTApp } from '@/plugins/core/app'
import { pardakhtShakhsiService } from '@/common/api.service'
import $ from "jquery";
import managePs from './components/manage-ps'
import {KTUtil} from "@/plugins/core/util";

export default {
    components: {
        mainContent,
        'ps-form': PSForm,
        'manage-ps': managePs
    },
    computed: {
        ...mapGetters('pardakhtShakhsi', [
            'form_data', 'status'
        ]),
        ...mapGetters('user', [
            'is_authenticated','current_user'
        ]),
    },
    methods: {
        submit(e) {
            let form = $('#ps_form')
            let btn = $('#submit_btn')
            form.validate({
                rules: {
                    wage_type: {
                        required: true,
                    },
                    terminal_id: {
                        required: true,
                    }
                }
            })

            if(!form.valid()) {
                return
            }

            KTApp.progress(btn)

            let params = this.$store.getters['pardakhtShakhsi/form_data']

            // let form_data = new FormData
            pardakhtShakhsiService.update(params).then(response => {
                this.showMsg($('#ps_form'), 'success', response.data.message)
            })
                .catch(({response}) => {
                    if(response.data) {
                        form.validate().showErrors(response.data.data)
                    }
                    this.showMsg(form, 'danger', response.data.message)
                })
                .finally(() => {
                    KTApp.unprogress(btn)
                    KTUtil.scrollTop()
                })
        },
    },
    mounted() {
        if(this.current_user.id && !this.$can('manage','gateway'))
           this.$store.dispatch('pardakhtShakhsi/fetch')
    }
}
</script>

<style>

</style>